import React, { memo } from 'react';
import InfoBubble from '@gp/components/InfoBubble';
import './index.scss';
import { isIncludeConsole } from '@gp/utils/common';
import SvgIcon from '@/pages/home/components/SvgIcon';

interface Props {
  platform: 'mobile' | 'pc' | 'console' | 'all platforms' | (string & {});
  placeholder?: any;
  isBubble?: boolean; // 是否显示气泡
  bubbles?: {
    // 每个平台对应的气泡内容
    mobile: any;
    pc: any;
    console: any;
  } | null;
}

const DEFAULT_PROPS: Props = {
  platform: '',
  placeholder: null,
  isBubble: false,
  bubbles: null,
};

function PlatformIcon(props: Props) {
  const { platform: platformTemp, placeholder, isBubble, bubbles } = props;

  const platform =
    (Array.isArray(platformTemp)
      ? platformTemp.join(',')?.toLowerCase()
      : platformTemp?.trim()?.toLowerCase()) || '';

  return (
    <div className="dbg-platform-group">
      {typeof platform === 'string' && !!platform ? (
        <>
          {/* mobile */}
          {(platform?.toLowerCase() === 'all platforms' ||
            platform?.toLowerCase().includes('mobile')) &&
            getPlatformIcon('other-icon', isBubble as boolean, bubbles?.mobile)}
          {/* pc */}
          {(platform?.toLowerCase() === 'all platforms' ||
            platform?.toLowerCase().includes('pc')) &&
            getPlatformIcon('monitor', isBubble as boolean, bubbles?.pc)}
          {/* console */}
          {(platform?.toLowerCase() === 'all platforms' || isIncludeConsole(platform)) &&
            getPlatformIcon('game', isBubble as boolean, bubbles?.console)}
        </>
      ) : (
        placeholder
      )}
    </div>
  );
}

const getPlatformIcon = (
  platform: 'other-icon' | 'monitor' | 'game',
  isBubble: boolean,
  bubble: any,
) => {
  return isBubble ? (
    <InfoBubble
      className="globalpedia-modal-font14"
      theme="white"
      DomOrText={<SvgIcon type={platform} />}
      customBubbleContent={bubble || undefined}
    />
  ) : (
    <SvgIcon type={platform} />
  );
};

// props的默认值
PlatformIcon.defaultProps = DEFAULT_PROPS;

export default memo(PlatformIcon);
